/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Admin API
 * Areeb Admin REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateBrandLookupDto
 */
export interface CreateBrandLookupDto {
    /**
     * Unique brand code
     * @type {string}
     * @memberof CreateBrandLookupDto
     */
    code: string;
    /**
     * Brand name in English
     * @type {string}
     * @memberof CreateBrandLookupDto
     */
    nameEn: string;
    /**
     * Brand name in Arabic
     * @type {string}
     * @memberof CreateBrandLookupDto
     */
    nameAr?: string;
    /**
     * Brand image URL
     * @type {string}
     * @memberof CreateBrandLookupDto
     */
    imageUrl?: string;
    /**
     * Whether the brand is active
     * @type {boolean}
     * @memberof CreateBrandLookupDto
     */
    isActive?: boolean;
    /**
     * Sort order for display (1-1000)
     * @type {number}
     * @memberof CreateBrandLookupDto
     */
    sortOrder?: number;
}

/**
 * Check if a given object implements the CreateBrandLookupDto interface.
 */
export function instanceOfCreateBrandLookupDto(value: object): value is CreateBrandLookupDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('nameEn' in value) || value['nameEn'] === undefined) return false;
    return true;
}

export function CreateBrandLookupDtoFromJSON(json: any): CreateBrandLookupDto {
    return CreateBrandLookupDtoFromJSONTyped(json, false);
}

export function CreateBrandLookupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateBrandLookupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'nameEn': json['nameEn'],
        'nameAr': json['nameAr'] == null ? undefined : json['nameAr'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'sortOrder': json['sortOrder'] == null ? undefined : json['sortOrder'],
    };
}

export function CreateBrandLookupDtoToJSON(value?: CreateBrandLookupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'nameEn': value['nameEn'],
        'nameAr': value['nameAr'],
        'imageUrl': value['imageUrl'],
        'isActive': value['isActive'],
        'sortOrder': value['sortOrder'],
    };
}

